<template>
    <div>
        底部
    </div>
</template>

<script>
export default {
    name: 'CrmMisComfooter',

    data() {
        return {
            
        };
    },

    mounted() {
        
    },

    methods: {
        
    },
};
</script>

<style lang="scss" scoped>

</style>